module.exports = __webpack_public_path__ + "static/media/logowithoutback.37cda906.png";